import { render } from "./NRestorePassword.vue?vue&type=template&id=665493c4"
import script from "./NRestorePassword.vue?vue&type=script&lang=js"
export * from "./NRestorePassword.vue?vue&type=script&lang=js"

import "./NRestorePassword.vue?vue&type=style&index=0&id=665493c4&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__